export default __webpack_public_path__ + "8f1d2cbd60dc4af1393f78556b7905ea.png";